import { AuthenticationController } from './Controllers/authentication'

export default class AuthenticationService {
  static authenticationController = AuthenticationController
}
